
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/en/giveback",
      function () {
        return require("private-next-pages/fr/en/giveback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/en/giveback"])
      });
    }
  